import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SendNotification } from '../../interfaces/send-notification';
import { NAVIGATOR_TOKEN } from '../../../shared/utils/navigator-token';
import { UserDevicesService } from './user-devices.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private notificationAudio = new Audio('assets/audio/notifySound.mp3');

  private navigator = inject(NAVIGATOR_TOKEN);

  constructor(private translate: TranslateService, private userDevicesService: UserDevicesService) {}

  async sendNotification({
    message,
    type,
    notification,
    timeout,
    tag,
  }: SendNotification) {
    if (this.navigator && this.navigator.serviceWorker) {
      const notificationMessage = this.translate.instant(message);
      await this.navigator.serviceWorker.register('service-worker.js');

      await this.navigator.serviceWorker.ready;

      const serviceWorkerController = new Promise((resolve: any) => {
        if (this.navigator && this.navigator.serviceWorker.controller) {
          return resolve();
        }
        this.navigator.serviceWorker.addEventListener('controllerchange', (_) =>
          resolve()
        );
      });

      const notificationData = {
        type,
        notification,
      };

      serviceWorkerController.then((_) => {
        this.navigator?.serviceWorker?.controller?.postMessage({
          type: 'notification',
          configuration: {
            title: 'Asksuite',
            notification: {
              body: notificationMessage,
              icon:
                notification?.notification?.icon ||
                'assets/img/logo-square-orange.png',
              requireInteraction: true,
              tag,
              data: notificationData,
            },
            timeout,
          },
        });
        this.playNotificationSound();
      });
    }
  }

  public playNotificationSound(): void {
    if (this.userDevicesService.isIOS()) return;
    this.notificationAudio.play().then().catch((error) => {});
  }

}
